import ApiClient from 'remote/api-client';

const logout = async () => ApiClient.post('/logout').promise();

export default {
  logout,
};
